import React from "react";
import cns from "classnames";
import MenuItem from "@material-ui/core/MenuItem";
import { ThemeType } from "@theme";
import Highlighter from "../Highlighter";
import { Small } from "../typography/Small";
import { OptionComponentProps } from "./utils";
import { makeStyles } from "@material-ui/core/styles";

type Props = OptionComponentProps & {
  children?: React.ReactNode;
};

export function SelectOptionMui(props: Props) {
  const classes = useStyles({});
  const {
    isDisabled,
    isGroup,
    isFocused,
    isSelected,
    isGroupOpen,
    handleDropdownItemClick
  } = props;

  const fontWeight = isSelected ? 500 : 400;

  return (
    <MenuItem
      className={cns(classes.root, props.className, {
        [classes.menuWithDropdownItem]: isGroup,
        [classes.withDesc]: Boolean(props.option.description)
      })}
      component={"div" as any}
      disabled={isDisabled}
      onClick={
        props.option.unselectable
          ? handleDropdownItemClick
          : () => props.onSelect(props.option)
      }
      onFocus={props.onFocus}
      selected={isFocused}
      style={{
        fontWeight,
        paddingLeft: 8 + props.parentLevel * 2 * 8
      }}
      data-test="SelectOption"
      data-test-id={props.option.value}
    >
      <Highlighter search={props.inputValue}>{props.children}</Highlighter>
      {isGroup && (
        <div className={classes.dropdownItem} onClick={handleDropdownItemClick}>
          <span
            className={cns(classes.dropdownArrow, {
              [classes.dropdownArrowOpen]: isGroupOpen
            })}
          >
            <svg
              fill="currentColor"
              preserveAspectRatio="xMidYMid meet"
              height="1em"
              width="1em"
              viewBox="0 0 40 40"
              style={{ verticalAlign: "middle" }}
            >
              <g>
                <path d="m11.6 16.6h16.8l-8.4 8.4z" />
              </g>
            </svg>
          </span>
        </div>
      )}

      {props.option.description && (
        <div className={classes.desc}>
          <Small>
            <Highlighter search={props.inputValue}>
              {props.option.description}
            </Highlighter>
          </Small>
        </div>
      )}
    </MenuItem>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    height: "auto",
    flexWrap: "wrap"
  },

  withDesc: {
    // height: "auto",
    // minHeight: 36
  },

  menuWithDropdownItem: {
    position: "relative",
    paddingRight: 50
  },

  dropdownItem: {
    width: 50,
    height: "100%",
    position: "absolute",
    top: 0,
    right: 0,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  dropdownArrow: {
    transition: "all 0.5s ease-in-out"
  },

  dropdownArrowOpen: {
    transform: "rotate(180deg)"
  },

  desc: {
    flex: "1 0 100%"
    // marginLeft: 32
  }
}));
